import React from "react";
import { motion } from "framer-motion";
import { ICONS } from "@/components/site/Needs";
import { Sparkles } from "lucide-react";

export default function Modalities({ items = [] }) {
  return (
    <section className="py-16 md:py-24" style={{ background: "var(--ev-bg-2)" }}>
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <div className="max-w-2xl">
          <div className="eyebrow">Areas of expertise</div>
          <h2 className="font-serif-ev mt-4 text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight">
            Modalities woven into every session.
          </h2>
        </div>

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
          {items.map((m, i) => {
            const Icon = ICONS[m.icon] || Sparkles;
            return (
              <motion.article
                key={m.id}
                initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: i * 0.05 }}
                className="ev-card p-7 md:p-9 smooth-hover"
              >
                <div className="flex items-start gap-5">
                  <div className="ev-icon-square flex-shrink-0">
                    <Icon className="w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="font-serif-ev text-2xl md:text-3xl leading-tight">{m.title}</h3>
                    <p className="mt-3 text-[15px] md:text-base" style={{ color: "var(--ev-muted)" }}>
                      {m.description}
                    </p>
                  </div>
                </div>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
